import { render } from "./MemoriamSection.vue?vue&type=template&id=6eff2a87&scoped=true"
import script from "./MemoriamSection.vue?vue&type=script&lang=js"
export * from "./MemoriamSection.vue?vue&type=script&lang=js"

import "./MemoriamSection.vue?vue&type=style&index=0&id=6eff2a87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eff2a87"]])

export default __exports__